import axios from 'axios';
import { toLower } from 'ramda';
import translate from 'counterpart';

import { requestMapper, responseMapper } from './mappers';
import { mapObjectKeys } from 'utils/ramdaAdditions';

class HttpError {
    constructor(error) {
        const { response = {} } = error;

        this.origin = error;

        this.headers = mapObjectKeys(toLower, response.headers);
        this.data = response.data;
        this.status = response.status;
        this.code = parseInt(this.headers['x-error-code'], 10) || 'unknown';
        this.translate = 'error.' + this.code;
        this.message = translate(this.translate, { unsafe: true });
    }
}

const errorHandler = (error) => {
    const httpError = new HttpError(error);
    return Promise.reject(httpError);
};

export function provideRequestInterceptors() {
    axios.interceptors.request.use(
        (config) => requestMapper(config),
        errorHandler
    );
}

export function provideResponseInterceptors() {
    axios.interceptors.response.use(
        (response) => responseMapper(response),
        errorHandler
    );
}
